import React, { useState } from "react";
import Modal from "components/foundation/Modal/Modal";

interface AlertProps {
  title: string;
  content: string;
  onConfirm?: (() => void) | boolean;
}

const Alert = ({ title, content, onConfirm = true }: AlertProps) => {
  const [open, setOpen] = useState(true);
  return (
    <Modal.Root open={open} onOpenChange={(open) => setOpen(open)}>
      <Modal.Body title={title} onConfirm={onConfirm}>
        {content}
      </Modal.Body>
    </Modal.Root>
  );
};

export default Alert;
